import { createReducer } from '@reduxjs/toolkit';
import giftToggle from '../actions/giftToggle';

const initialState = {
  visible: false,
};
export default createReducer(initialState, (builder) => {
  builder.addCase(giftToggle, (state, action) => ({
    ...state,
    visible: action.payload,
  }));
});
